import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=113c745d&"
import script from "./attachment.vue?vue&type=script&lang=ts&"
export * from "./attachment.vue?vue&type=script&lang=ts&"
import style0 from "./attachment.vue?vue&type=style&index=0&id=113c745d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports